/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../app/routers/__root'
import { Route as ForbiddenRouteImport } from './../../app/routers/forbidden'
import { Route as PublicRouteRouteImport } from './../../app/routers/_public/route'
import { Route as PrivateRouteRouteImport } from './../../app/routers/_private/route'
import { Route as PrivateIndexRouteImport } from './../../app/routers/_private/index'
import { Route as PublicVerifyUserRouteImport } from './../../app/routers/_public/verify-user'
import { Route as PublicVerifyOtpRouteImport } from './../../app/routers/_public/verify-otp'
import { Route as PublicSignInWithEventCodeRouteImport } from './../../app/routers/_public/sign-in-with-event-code'
import { Route as PublicSignInRouteImport } from './../../app/routers/_public/sign-in'
import { Route as PublicResetPasswordRouteImport } from './../../app/routers/_public/reset-password'
import { Route as PublicForgotPasswordRouteImport } from './../../app/routers/_public/forgot-password'
import { Route as PrivateTermsAndConditionsRouteImport } from './../../app/routers/_private/terms-and-conditions'
import { Route as PrivateSettingsIndexRouteImport } from './../../app/routers/_private/settings/index'
import { Route as PrivateReportingIndexRouteImport } from './../../app/routers/_private/reporting/index'
import { Route as PrivateEventsIndexRouteImport } from './../../app/routers/_private/events/index'
import { Route as PublicAuthCallbackRouteImport } from './../../app/routers/_public/auth/callback'
import { Route as PrivateReportingRecentIncidentsRouteImport } from './../../app/routers/_private/reporting/recent-incidents'
import { Route as PrivateReportingRecentEventsRouteImport } from './../../app/routers/_private/reporting/recent-events'
import { Route as PrivateOnDayPromptEventUuidRouteImport } from './../../app/routers/_private/on-day-prompt/$eventUuid'
import { Route as PrivateManageUsersRouteImport } from './../../app/routers/_private/manage/users'
import { Route as PrivateEventsCreateRouteImport } from './../../app/routers/_private/events/create'
import { Route as PrivateManageOrganisationsIndexRouteImport } from './../../app/routers/_private/manage/organisations/index'
import { Route as PrivateManageClientGroupsIndexRouteImport } from './../../app/routers/_private/manage/client-groups/index'
import { Route as PrivateEventsEventUuidIndexRouteImport } from './../../app/routers/_private/events/$eventUuid/index'
import { Route as PrivateEventsEventUuidDetailRouteImport } from './../../app/routers/_private/events/$eventUuid/detail'
import { Route as PrivateEventsEventUuidClosureReportRouteImport } from './../../app/routers/_private/events/$eventUuid/closure-report'
import { Route as PrivateEventsEventUuidIncidentCreateRouteImport } from './../../app/routers/_private/events/$eventUuid/incident/create'
import { Route as PrivateEventsEventUuidIncidentIncidentUuidRouteImport } from './../../app/routers/_private/events/$eventUuid/incident/$incidentUuid'

const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateIndexRoute = PrivateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PublicVerifyUserRoute = PublicVerifyUserRouteImport.update({
  id: '/verify-user',
  path: '/verify-user',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicVerifyOtpRoute = PublicVerifyOtpRouteImport.update({
  id: '/verify-otp',
  path: '/verify-otp',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicSignInWithEventCodeRoute =
  PublicSignInWithEventCodeRouteImport.update({
    id: '/sign-in-with-event-code',
    path: '/sign-in-with-event-code',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateTermsAndConditionsRoute =
  PrivateTermsAndConditionsRouteImport.update({
    id: '/terms-and-conditions',
    path: '/terms-and-conditions',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateSettingsIndexRoute = PrivateSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateReportingIndexRoute = PrivateReportingIndexRouteImport.update({
  id: '/reporting/',
  path: '/reporting/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateEventsIndexRoute = PrivateEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PublicAuthCallbackRoute = PublicAuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateReportingRecentIncidentsRoute =
  PrivateReportingRecentIncidentsRouteImport.update({
    id: '/reporting/recent-incidents',
    path: '/reporting/recent-incidents',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateReportingRecentEventsRoute =
  PrivateReportingRecentEventsRouteImport.update({
    id: '/reporting/recent-events',
    path: '/reporting/recent-events',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateOnDayPromptEventUuidRoute =
  PrivateOnDayPromptEventUuidRouteImport.update({
    id: '/on-day-prompt/$eventUuid',
    path: '/on-day-prompt/$eventUuid',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateManageUsersRoute = PrivateManageUsersRouteImport.update({
  id: '/manage/users',
  path: '/manage/users',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateEventsCreateRoute = PrivateEventsCreateRouteImport.update({
  id: '/events/create',
  path: '/events/create',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateManageOrganisationsIndexRoute =
  PrivateManageOrganisationsIndexRouteImport.update({
    id: '/manage/organisations/',
    path: '/manage/organisations/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateManageClientGroupsIndexRoute =
  PrivateManageClientGroupsIndexRouteImport.update({
    id: '/manage/client-groups/',
    path: '/manage/client-groups/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateEventsEventUuidIndexRoute =
  PrivateEventsEventUuidIndexRouteImport.update({
    id: '/events/$eventUuid/',
    path: '/events/$eventUuid/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateEventsEventUuidDetailRoute =
  PrivateEventsEventUuidDetailRouteImport.update({
    id: '/events/$eventUuid/detail',
    path: '/events/$eventUuid/detail',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateEventsEventUuidClosureReportRoute =
  PrivateEventsEventUuidClosureReportRouteImport.update({
    id: '/events/$eventUuid/closure-report',
    path: '/events/$eventUuid/closure-report',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateEventsEventUuidIncidentCreateRoute =
  PrivateEventsEventUuidIncidentCreateRouteImport.update({
    id: '/events/$eventUuid/incident/create',
    path: '/events/$eventUuid/incident/create',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateEventsEventUuidIncidentIncidentUuidRoute =
  PrivateEventsEventUuidIncidentIncidentUuidRouteImport.update({
    id: '/events/$eventUuid/incident/$incidentUuid',
    path: '/events/$eventUuid/incident/$incidentUuid',
    getParentRoute: () => PrivateRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/forbidden': typeof ForbiddenRoute
  '/terms-and-conditions': typeof PrivateTermsAndConditionsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-in-with-event-code': typeof PublicSignInWithEventCodeRoute
  '/verify-otp': typeof PublicVerifyOtpRoute
  '/verify-user': typeof PublicVerifyUserRoute
  '/': typeof PrivateIndexRoute
  '/events/create': typeof PrivateEventsCreateRoute
  '/manage/users': typeof PrivateManageUsersRoute
  '/on-day-prompt/$eventUuid': typeof PrivateOnDayPromptEventUuidRoute
  '/reporting/recent-events': typeof PrivateReportingRecentEventsRoute
  '/reporting/recent-incidents': typeof PrivateReportingRecentIncidentsRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/events': typeof PrivateEventsIndexRoute
  '/reporting': typeof PrivateReportingIndexRoute
  '/settings': typeof PrivateSettingsIndexRoute
  '/events/$eventUuid/closure-report': typeof PrivateEventsEventUuidClosureReportRoute
  '/events/$eventUuid/detail': typeof PrivateEventsEventUuidDetailRoute
  '/events/$eventUuid': typeof PrivateEventsEventUuidIndexRoute
  '/manage/client-groups': typeof PrivateManageClientGroupsIndexRoute
  '/manage/organisations': typeof PrivateManageOrganisationsIndexRoute
  '/events/$eventUuid/incident/$incidentUuid': typeof PrivateEventsEventUuidIncidentIncidentUuidRoute
  '/events/$eventUuid/incident/create': typeof PrivateEventsEventUuidIncidentCreateRoute
}
export interface FileRoutesByTo {
  '/forbidden': typeof ForbiddenRoute
  '/terms-and-conditions': typeof PrivateTermsAndConditionsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-in-with-event-code': typeof PublicSignInWithEventCodeRoute
  '/verify-otp': typeof PublicVerifyOtpRoute
  '/verify-user': typeof PublicVerifyUserRoute
  '/': typeof PrivateIndexRoute
  '/events/create': typeof PrivateEventsCreateRoute
  '/manage/users': typeof PrivateManageUsersRoute
  '/on-day-prompt/$eventUuid': typeof PrivateOnDayPromptEventUuidRoute
  '/reporting/recent-events': typeof PrivateReportingRecentEventsRoute
  '/reporting/recent-incidents': typeof PrivateReportingRecentIncidentsRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/events': typeof PrivateEventsIndexRoute
  '/reporting': typeof PrivateReportingIndexRoute
  '/settings': typeof PrivateSettingsIndexRoute
  '/events/$eventUuid/closure-report': typeof PrivateEventsEventUuidClosureReportRoute
  '/events/$eventUuid/detail': typeof PrivateEventsEventUuidDetailRoute
  '/events/$eventUuid': typeof PrivateEventsEventUuidIndexRoute
  '/manage/client-groups': typeof PrivateManageClientGroupsIndexRoute
  '/manage/organisations': typeof PrivateManageOrganisationsIndexRoute
  '/events/$eventUuid/incident/$incidentUuid': typeof PrivateEventsEventUuidIncidentIncidentUuidRoute
  '/events/$eventUuid/incident/create': typeof PrivateEventsEventUuidIncidentCreateRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_private': typeof PrivateRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/_private/terms-and-conditions': typeof PrivateTermsAndConditionsRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/sign-in': typeof PublicSignInRoute
  '/_public/sign-in-with-event-code': typeof PublicSignInWithEventCodeRoute
  '/_public/verify-otp': typeof PublicVerifyOtpRoute
  '/_public/verify-user': typeof PublicVerifyUserRoute
  '/_private/': typeof PrivateIndexRoute
  '/_private/events/create': typeof PrivateEventsCreateRoute
  '/_private/manage/users': typeof PrivateManageUsersRoute
  '/_private/on-day-prompt/$eventUuid': typeof PrivateOnDayPromptEventUuidRoute
  '/_private/reporting/recent-events': typeof PrivateReportingRecentEventsRoute
  '/_private/reporting/recent-incidents': typeof PrivateReportingRecentIncidentsRoute
  '/_public/auth/callback': typeof PublicAuthCallbackRoute
  '/_private/events/': typeof PrivateEventsIndexRoute
  '/_private/reporting/': typeof PrivateReportingIndexRoute
  '/_private/settings/': typeof PrivateSettingsIndexRoute
  '/_private/events/$eventUuid/closure-report': typeof PrivateEventsEventUuidClosureReportRoute
  '/_private/events/$eventUuid/detail': typeof PrivateEventsEventUuidDetailRoute
  '/_private/events/$eventUuid/': typeof PrivateEventsEventUuidIndexRoute
  '/_private/manage/client-groups/': typeof PrivateManageClientGroupsIndexRoute
  '/_private/manage/organisations/': typeof PrivateManageOrganisationsIndexRoute
  '/_private/events/$eventUuid/incident/$incidentUuid': typeof PrivateEventsEventUuidIncidentIncidentUuidRoute
  '/_private/events/$eventUuid/incident/create': typeof PrivateEventsEventUuidIncidentCreateRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forbidden'
    | '/terms-and-conditions'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-with-event-code'
    | '/verify-otp'
    | '/verify-user'
    | '/'
    | '/events/create'
    | '/manage/users'
    | '/on-day-prompt/$eventUuid'
    | '/reporting/recent-events'
    | '/reporting/recent-incidents'
    | '/auth/callback'
    | '/events'
    | '/reporting'
    | '/settings'
    | '/events/$eventUuid/closure-report'
    | '/events/$eventUuid/detail'
    | '/events/$eventUuid'
    | '/manage/client-groups'
    | '/manage/organisations'
    | '/events/$eventUuid/incident/$incidentUuid'
    | '/events/$eventUuid/incident/create'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forbidden'
    | '/terms-and-conditions'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-with-event-code'
    | '/verify-otp'
    | '/verify-user'
    | '/'
    | '/events/create'
    | '/manage/users'
    | '/on-day-prompt/$eventUuid'
    | '/reporting/recent-events'
    | '/reporting/recent-incidents'
    | '/auth/callback'
    | '/events'
    | '/reporting'
    | '/settings'
    | '/events/$eventUuid/closure-report'
    | '/events/$eventUuid/detail'
    | '/events/$eventUuid'
    | '/manage/client-groups'
    | '/manage/organisations'
    | '/events/$eventUuid/incident/$incidentUuid'
    | '/events/$eventUuid/incident/create'
  id:
    | '__root__'
    | '/_private'
    | '/_public'
    | '/forbidden'
    | '/_private/terms-and-conditions'
    | '/_public/forgot-password'
    | '/_public/reset-password'
    | '/_public/sign-in'
    | '/_public/sign-in-with-event-code'
    | '/_public/verify-otp'
    | '/_public/verify-user'
    | '/_private/'
    | '/_private/events/create'
    | '/_private/manage/users'
    | '/_private/on-day-prompt/$eventUuid'
    | '/_private/reporting/recent-events'
    | '/_private/reporting/recent-incidents'
    | '/_public/auth/callback'
    | '/_private/events/'
    | '/_private/reporting/'
    | '/_private/settings/'
    | '/_private/events/$eventUuid/closure-report'
    | '/_private/events/$eventUuid/detail'
    | '/_private/events/$eventUuid/'
    | '/_private/manage/client-groups/'
    | '/_private/manage/organisations/'
    | '/_private/events/$eventUuid/incident/$incidentUuid'
    | '/_private/events/$eventUuid/incident/create'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/': {
      id: '/_private/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PrivateIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_public/verify-user': {
      id: '/_public/verify-user'
      path: '/verify-user'
      fullPath: '/verify-user'
      preLoaderRoute: typeof PublicVerifyUserRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/verify-otp': {
      id: '/_public/verify-otp'
      path: '/verify-otp'
      fullPath: '/verify-otp'
      preLoaderRoute: typeof PublicVerifyOtpRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/sign-in-with-event-code': {
      id: '/_public/sign-in-with-event-code'
      path: '/sign-in-with-event-code'
      fullPath: '/sign-in-with-event-code'
      preLoaderRoute: typeof PublicSignInWithEventCodeRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/terms-and-conditions': {
      id: '/_private/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof PrivateTermsAndConditionsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/settings/': {
      id: '/_private/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateSettingsIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/reporting/': {
      id: '/_private/reporting/'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof PrivateReportingIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/events/': {
      id: '/_private/events/'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof PrivateEventsIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_public/auth/callback': {
      id: '/_public/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof PublicAuthCallbackRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/reporting/recent-incidents': {
      id: '/_private/reporting/recent-incidents'
      path: '/reporting/recent-incidents'
      fullPath: '/reporting/recent-incidents'
      preLoaderRoute: typeof PrivateReportingRecentIncidentsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/reporting/recent-events': {
      id: '/_private/reporting/recent-events'
      path: '/reporting/recent-events'
      fullPath: '/reporting/recent-events'
      preLoaderRoute: typeof PrivateReportingRecentEventsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/on-day-prompt/$eventUuid': {
      id: '/_private/on-day-prompt/$eventUuid'
      path: '/on-day-prompt/$eventUuid'
      fullPath: '/on-day-prompt/$eventUuid'
      preLoaderRoute: typeof PrivateOnDayPromptEventUuidRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/manage/users': {
      id: '/_private/manage/users'
      path: '/manage/users'
      fullPath: '/manage/users'
      preLoaderRoute: typeof PrivateManageUsersRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/events/create': {
      id: '/_private/events/create'
      path: '/events/create'
      fullPath: '/events/create'
      preLoaderRoute: typeof PrivateEventsCreateRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/manage/organisations/': {
      id: '/_private/manage/organisations/'
      path: '/manage/organisations'
      fullPath: '/manage/organisations'
      preLoaderRoute: typeof PrivateManageOrganisationsIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/manage/client-groups/': {
      id: '/_private/manage/client-groups/'
      path: '/manage/client-groups'
      fullPath: '/manage/client-groups'
      preLoaderRoute: typeof PrivateManageClientGroupsIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/events/$eventUuid/': {
      id: '/_private/events/$eventUuid/'
      path: '/events/$eventUuid'
      fullPath: '/events/$eventUuid'
      preLoaderRoute: typeof PrivateEventsEventUuidIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/events/$eventUuid/detail': {
      id: '/_private/events/$eventUuid/detail'
      path: '/events/$eventUuid/detail'
      fullPath: '/events/$eventUuid/detail'
      preLoaderRoute: typeof PrivateEventsEventUuidDetailRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/events/$eventUuid/closure-report': {
      id: '/_private/events/$eventUuid/closure-report'
      path: '/events/$eventUuid/closure-report'
      fullPath: '/events/$eventUuid/closure-report'
      preLoaderRoute: typeof PrivateEventsEventUuidClosureReportRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/events/$eventUuid/incident/create': {
      id: '/_private/events/$eventUuid/incident/create'
      path: '/events/$eventUuid/incident/create'
      fullPath: '/events/$eventUuid/incident/create'
      preLoaderRoute: typeof PrivateEventsEventUuidIncidentCreateRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/events/$eventUuid/incident/$incidentUuid': {
      id: '/_private/events/$eventUuid/incident/$incidentUuid'
      path: '/events/$eventUuid/incident/$incidentUuid'
      fullPath: '/events/$eventUuid/incident/$incidentUuid'
      preLoaderRoute: typeof PrivateEventsEventUuidIncidentIncidentUuidRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
  }
}

interface PrivateRouteRouteChildren {
  PrivateTermsAndConditionsRoute: typeof PrivateTermsAndConditionsRoute
  PrivateIndexRoute: typeof PrivateIndexRoute
  PrivateEventsCreateRoute: typeof PrivateEventsCreateRoute
  PrivateManageUsersRoute: typeof PrivateManageUsersRoute
  PrivateOnDayPromptEventUuidRoute: typeof PrivateOnDayPromptEventUuidRoute
  PrivateReportingRecentEventsRoute: typeof PrivateReportingRecentEventsRoute
  PrivateReportingRecentIncidentsRoute: typeof PrivateReportingRecentIncidentsRoute
  PrivateEventsIndexRoute: typeof PrivateEventsIndexRoute
  PrivateReportingIndexRoute: typeof PrivateReportingIndexRoute
  PrivateSettingsIndexRoute: typeof PrivateSettingsIndexRoute
  PrivateEventsEventUuidClosureReportRoute: typeof PrivateEventsEventUuidClosureReportRoute
  PrivateEventsEventUuidDetailRoute: typeof PrivateEventsEventUuidDetailRoute
  PrivateEventsEventUuidIndexRoute: typeof PrivateEventsEventUuidIndexRoute
  PrivateManageClientGroupsIndexRoute: typeof PrivateManageClientGroupsIndexRoute
  PrivateManageOrganisationsIndexRoute: typeof PrivateManageOrganisationsIndexRoute
  PrivateEventsEventUuidIncidentIncidentUuidRoute: typeof PrivateEventsEventUuidIncidentIncidentUuidRoute
  PrivateEventsEventUuidIncidentCreateRoute: typeof PrivateEventsEventUuidIncidentCreateRoute
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateTermsAndConditionsRoute: PrivateTermsAndConditionsRoute,
  PrivateIndexRoute: PrivateIndexRoute,
  PrivateEventsCreateRoute: PrivateEventsCreateRoute,
  PrivateManageUsersRoute: PrivateManageUsersRoute,
  PrivateOnDayPromptEventUuidRoute: PrivateOnDayPromptEventUuidRoute,
  PrivateReportingRecentEventsRoute: PrivateReportingRecentEventsRoute,
  PrivateReportingRecentIncidentsRoute: PrivateReportingRecentIncidentsRoute,
  PrivateEventsIndexRoute: PrivateEventsIndexRoute,
  PrivateReportingIndexRoute: PrivateReportingIndexRoute,
  PrivateSettingsIndexRoute: PrivateSettingsIndexRoute,
  PrivateEventsEventUuidClosureReportRoute:
    PrivateEventsEventUuidClosureReportRoute,
  PrivateEventsEventUuidDetailRoute: PrivateEventsEventUuidDetailRoute,
  PrivateEventsEventUuidIndexRoute: PrivateEventsEventUuidIndexRoute,
  PrivateManageClientGroupsIndexRoute: PrivateManageClientGroupsIndexRoute,
  PrivateManageOrganisationsIndexRoute: PrivateManageOrganisationsIndexRoute,
  PrivateEventsEventUuidIncidentIncidentUuidRoute:
    PrivateEventsEventUuidIncidentIncidentUuidRoute,
  PrivateEventsEventUuidIncidentCreateRoute:
    PrivateEventsEventUuidIncidentCreateRoute,
}

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignInRoute: typeof PublicSignInRoute
  PublicSignInWithEventCodeRoute: typeof PublicSignInWithEventCodeRoute
  PublicVerifyOtpRoute: typeof PublicVerifyOtpRoute
  PublicVerifyUserRoute: typeof PublicVerifyUserRoute
  PublicAuthCallbackRoute: typeof PublicAuthCallbackRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignInRoute: PublicSignInRoute,
  PublicSignInWithEventCodeRoute: PublicSignInWithEventCodeRoute,
  PublicVerifyOtpRoute: PublicVerifyOtpRoute,
  PublicVerifyUserRoute: PublicVerifyUserRoute,
  PublicAuthCallbackRoute: PublicAuthCallbackRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
